import { getToken, getUser } from "../../Utils/Common";
import { getAPICall, postAPICall } from "../axiosMethodCalls";
import Moment from "moment";

export const getJobOrder = async (info) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "job_orders/get",
            {
                requester: getUser(),
                token: getToken(),
                job_order_id: info.job_order_id ,
                status: info.status,
                build_item_id: info.build_item_id,
                page: info.page
                // date_from: info.date_from ? Moment(info.date_from).format("YYYY-MM-DD") : info.date_from,
                // date_to: info.date_to ? Moment(info.date_to).format("YYYY-MM-DD"): info.date_to,
            }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

//POST
export const createJobOrder = async (data, items) => {

    let form_data = new FormData();
    data.attachments.map((file) => {
        form_data.append(`attachments[]`, file, file.name);
    })
    form_data.append("requester", getUser());
    form_data.append("token", getToken());
    form_data.append("branch_from", data.branch_from);
    form_data.append("type", data.type);
    form_data.append("build_item_id", data.build_item_id ? data.build_item_id : "");
    form_data.append("build_item_qty", data.build_item_qty ? data.build_item_qty : "");
    form_data.append("build_item_unit", data.build_item_unit ? data.build_item_unit : "");
    form_data.append("build_item_unit_id", data.build_item_unit_id ? data.build_item_unit_id : "");
    form_data.append("job_order_no", data.job_order_no ? data.job_order_no : "");
    form_data.append("branch_to", data.branch_to ? data.branch_to : "");
    form_data.append("job_requesting_to", data.job_requesting_to ? data.job_requesting_to : "");
    form_data.append("schedule_date", data.schedule_date ? data.schedule_date.split("T").join(" ") + ":00" : "");
    form_data.append("job_order_date", data.job_order_date ? data.job_order_date : "");
    form_data.append("requested_by", data.requested_by ? data.requested_by : "");
    // form_data.append("requested_to", data.requested_to);
    form_data.append("description", data.description ? data.description : "");
    form_data.append("estimated_time", data.estimated_time ? data.estimated_time : "");
    form_data.append("date_completed", data.date_completed ? data.date_completed : "");
    form_data.append("time_in", data.time_in ? data.time_in.split("T").join(" ") + ":00" : "");
    form_data.append("time_end", data.time_end ? data.time_end.split("T").join(" ") + ":00" : "");
    form_data.append("acknowledge_by", data.acknowledge_by ? data.acknowledge_by : "");
    form_data.append("change_status_by", data.change_status_by ? data.change_status_by : "");
    form_data.append("status", data.status ? data.status : "");
    form_data.append("remarks", data.remarks ? data.remarks : "");
    items.map((item) => {
        form_data.append(`item_id[]`,item.item_id ? item.item_id : "");
        form_data.append(`qty[]`,item.qty ? item.qty : "");
        form_data.append(`qty_used[]`,item.qty_used ? item.qty_used : "");
        form_data.append(`item_unit_id[]`,item.item_unit_id ? item.item_unit_id : "");
        form_data.append(`unit[]`,item.unit ? item.unit : "");
    })
    try {
        const response = await postAPICall(
            process.env.REACT_APP_LINK + "job_orders/create", form_data
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};

export const updateJobOrder = async (data, items) => {
    let form_data = new FormData();
    data.attachments.map((file) => {
        form_data.append('attachments[]', file, file.name);
        form_data.append('attachment_ids[]', null);
    });
    data.prev_files.map((file) => {
        form_data.append('attachment_ids[]', file.id);
    });
    form_data.append("requester", getUser());
    form_data.append("token", getToken());
    form_data.append("job_order_id", data.id);
    form_data.append("branch_from", data.branch_from);
    form_data.append("type", data.type);
    form_data.append("build_item_id", data.build_item_id ? data.build_item_id : "");
    form_data.append("build_item_qty", data.build_item_qty ? data.build_item_qty : "");
    form_data.append("build_item_unit", data.build_item_unit ? data.build_item_unit : "");
    form_data.append("build_item_unit_id", data.build_item_unit_id ? data.build_item_unit_id : "");
    form_data.append("job_order_no", data.job_order_no ? data.job_order_no : "");
    form_data.append("branch_to", data.branch_to ? data.branch_to : "");
    form_data.append("job_requesting_to", data.job_requesting_to ? data.job_requesting_to : "");
    form_data.append("schedule_date", data.schedule_date ? data.schedule_date.split("T").length > 1 ? data.schedule_date.split("T").join(" ") + ":00" : data.schedule_date : "");
    form_data.append("job_order_date", data.job_order_date ? data.job_order_date : "");
    form_data.append("requested_by", data.requested_by ? data.requested_by : "");
    // form_data.append("requested_to", data.requested_to);
    form_data.append("description", data.description ? data.description : "");
    form_data.append("estimated_time", data.estimated_time ? data.estimated_time : "");
    form_data.append("date_completed", data.date_completed ? data.date_completed : "");
    form_data.append("time_in", data.time_in ? data.time_in.split("T").length > 1 ? data.time_in.split("T").join(" ") + ":00" : data.time_in : "");
    form_data.append("time_end", data.time_end ? data.time_end.split("T").length > 1 ? data.time_end.split("T").join(" ") + ":00" : data.time_end : "");
    form_data.append("acknowledge_by", data.acknowledge_by ? data.acknowledge_by : "");
    form_data.append("change_status_by", data.change_status_by ? data.change_status_by : "");
    form_data.append("status", data.status ? data.status : "");
    form_data.append("remarks", data.remarks ? data.remarks : "");
    items.map((item) => {
        form_data.append(`item_id[]`,item.id ? item.id : "");
        form_data.append(`qty[]`,item.qty ? item.qty : "");
        form_data.append(`qty_used[]`,item.qty_used ? item.qty_used : "");
        form_data.append(`item_unit_id[]`,item.item_unit_id ? item.item_unit_id : "");
        form_data.append(`unit[]`,item.unit ? item.unit : "");
    })
    try {
        const response = await postAPICall(
            process.env.REACT_APP_LINK + "job_orders/update", form_data
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};

export const changeStatus = async (id, status) => {
    let form_data = new FormData();
    form_data.append("requester", getUser());
    form_data.append("token", getToken());
    form_data.append("job_order_id", id);
    form_data.append("status", status);
    try {
        const response = await postAPICall(
            process.env.REACT_APP_LINK + "job_orders/update_status", form_data
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};

export const deleteJobOrder = async (id) => {
    try {
        const response = await postAPICall(
            process.env.REACT_APP_LINK + "job_orders/delete",
            {
                requester: getUser(),
                token: getToken(),
                job_order_id: id,
            }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};
